<template>
     <div  class="pa-5 white">
        <block v-if="loading" />
           
        <v-row class="m-3">
            <v-col cols="12" md="6">
                <v-checkbox
                    v-model="search.showUnbalanced"
                   
                    label="Mostrar partidas descuadradas"
                    single-line
                    hide-details
                ></v-checkbox>
            </v-col>
            <v-col cols="12" md="6">
                <v-checkbox
                    v-model="search.showBalanced"
                    label="Mostrar partidas cuadradas"
                    single-line
                    hide-details
                ></v-checkbox>
            </v-col>
        </v-row>
        <!-- <date-filter class="item" v-if="!loading" @datesSelected="setDates" @filtered-data="dateFilterHandler" :dataToFilter="data" nameOfDate="History" :filterEndpoint="$API.accountlevel.getAcountingHeaderFilteredBydate" :isFilteredByOutsource="isFiltered"/>
        <br/> -->

        <v-row style="margin-top: 3rem; margin-bottom: 1rem;">
            <v-col cols="12" md="3">
                <v-select
                    v-model="search.month"
                    :items="monthList"
                    item-text="text"
                    item-value="value"
                    label="Mes"
                    outlined
                    attach
                    dense
                ></v-select>
            </v-col>
            <v-col cols="12" md="3">
                <v-text-field
                    v-model="search.year"
                    label="Año"
                    outlined
                    type="number"
                    @change="search.year = parseInt(search.year)"
                    attach
                    dense
                    clearable
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
                <div style="display: flex; flex-direction: row; align-items: center; justify-content: flex-end; gap: 2rem;">
                    <v-btn class="btn-save" @click="dateFilterHandler" :disabled="!search.month">Filtrar por mes</v-btn>
                    <v-btn class="btn-save" @click="getAcounteringHeader">Mostrar todos</v-btn>
                </div>
            </v-col>
            <v-col cols="12" md="6">
                <v-btn class="btn-save" @click="onExportingToPdf()">Exportar a pdf</v-btn>
                &nbsp;
                <v-btn class="btn-save" @click="exportarPartidasDetalladas()">Exportar reporte detallado a pdf</v-btn>
                &nbsp;
                <v-btn class="btn-save" @click="handleFixCorrelatives" :disabled="!filteredByDate || monthClosed">Corregir correlativos</v-btn>
            </v-col>
            <v-col cols="12" md="6">
                <v-autocomplete
                    label="Tipo"
                    v-model="search.type"
                    attach
                    outlined
                    :rules="[(v) => !!v || 'Este campo es requerido']"
                    required
                    id="jumper"
                    dense
                    clearable
                    item-value="id_accounting_entry_type"
                    item-text="accounting_entry_name"
                    :items="TypesItems"
                ></v-autocomplete>
            </v-col>
        </v-row>

        <GeneralFilter
            ref="generalFilter"
            entity="lista"
            :filterEndpoint="getFilteredAccountingHeaders"
            :search="search"
            :colMdSearch="'12'"
            @loading="loading = $event"
            @emptyFilter="getAcounteringHeader"
            @filtered="filterHandler"
            :twoSlots="true"
        >
            <template #additionalSearch>
                <v-text-field
                    v-model="search.generationCode"
                    outlined
                    dense
                    clearable
                    label="Código de generación"
                    style="min-width: 0; flex: 1 1 0; width: 50%; margin-right: 2%;"
                    @input="handleGenerationCodeInput"
                    @keyup.enter="filterByGenerationCode"
                    @click:clear="clearGenerationCode"
                ></v-text-field>
            </template>
            <DxDataGrid
                ref="dataGrid"
                class="mt-5 isScrolledByGeneralFilter"
                :dataSource="itemsHistory"
                :showBorders="true"
                :showRowLines="true"
                :word-wrap-enabled="true" 
                @exporting="onExporting"
                v-if="$store.getters['rolesUser/getCustomRole'](205)"
                >
                <DxColumn cell-template="show-details"  :width="50" v-if="$store.getters['rolesUser/getCustomRole'](202)"></DxColumn>
                <!-- <DxColumn dataField="id_accounting_entry" caption="ID" :width="50"></DxColumn> -->
                <DxColumn cell-template="imbalance" :width="50"></DxColumn>
                <DxColumn dataField="ID_Accounting_item" caption="Correlativo" sort-order="asc"></DxColumn>
                <DxColumn dataField="EntryFormatDate" caption="Fecha"  ></DxColumn>
                <DxColumn dataField="accounting_entry_comment" caption="Concepto" ></DxColumn>
                <DxColumn dataField="accounting_entry_value_toShow" caption="Valor" ></DxColumn>
                <DxColumn dataField="typeAcountname" caption="Tipo" ></DxColumn>

                <DxPager
                    :showPageSizeSelector="true"
                    :allowedPageSizes="[5, 10, 20, 50, 100]"
                />
                <DxPaging :pageSize="10" />
                <template #show-details="{data}">
                    <div>
                        <a href="#" class="mx-1"
                            @click="entryTypes != undefined ? sendetails(data.data) : accountingEntrySelected(data)">
                            <v-icon color="primary">mdi-eye</v-icon>
                        </a>
                    </div>
                </template>
                <template #imbalance="{data}">
                    <div>
                        <v-icon 
                        color="error"
                        v-if="data.data.diff < 0 || ( data.data.imbalance || ( typeof data.data.imbalance === 'string' && parseBoolean( data.data.imbalance ) ) )" title="Se indica la partida como descuadrada">mdi-alert</v-icon>
                        <v-icon 
                        color="success"
                        v-else title="La partida cuadra">mdi-check</v-icon>
                    </div>
                </template>
                <DxExport :enabled="true" :formats="['xlsx']" />
            </DxDataGrid>
        </GeneralFilter>
        <PrintReportePartidasDetallado :dataProps="print"></PrintReportePartidasDetallado>

        <alert
            v-model="alert.show"
            @action="alert.action"
            :type="alert.type"
            :title="alert.title"
        >
            {{ alert.message }}
        </alert>
    </div>
</template>
<script>
//import DateFilter from "@/components/DateFilter";
import Block from "@/components/Block.vue";
import GeneralFilter from "@/components/GeneralFilter";
import {DxDataGrid, DxColumn,  DxPager, DxPaging, DxExport } from 'devextreme-vue/data-grid';
import { multipleCriteriaFilter } from "../../../helpers/object";
import { printToExcel } from "@/helpers/printToexcel";
import { exportDataGrid } from 'devextreme/pdf_exporter';
import { jsPDF } from 'jspdf'
import 'jspdf-autotable';
import PrintReportePartidasDetallado from "../../../components/ReportsAndPrintings/PrintReportePartidasDetallado.vue";
import { parseBoolean } from "../../../helpers/misc";
    export default {
        name: "AcountItemHistory",
        props: ['win', 'entryTypes'],
        components: {
            DxDataGrid,
            DxColumn,
            DxPager,
            DxPaging,
            GeneralFilter,
            //DateFilter,
            Block,
            DxExport,
            PrintReportePartidasDetallado,
        },
        computed:{
            itemsHistory(){
                if(this.search.showUnbalanced && this.search.showBalanced){
                    return this.data;
                }
                if(this.search.showUnbalanced){
                    return this.data.filter((item) => item.diff < 0)
                }
                if(this.search.showBalanced){
                    return this.data.filter((item) => item.diff >= 0)
                }

                return [];
            },
        },
        watch: {
            'search.filter'(value) {
                if (value && this.search.generationCode) {
                    this.search.generationCode = null;
                }
            }
        },
        data() {
            return {
                TypesItems: [],
                panel: 0,
                isFiltered: false,
                data: [],
                loading: true,
                search: {
                    filter: null,
                    showUnbalanced: true,
                    showBalanced: true,
                    month: null,
                    type: null,
                    year: new Date().getFullYear(),
                    generationCode: null
                },
                monthList: [
                    {text: 'Enero', value: 1},
                    {text: 'Febrero', value: 2},
                    {text: 'Marzo', value: 3},
                    {text: 'Abril', value: 4},
                    {text: 'Mayo', value: 5},
                    {text: 'Junio', value: 6},
                    {text: 'Julio', value: 7},
                    {text: 'Agosto', value: 8},
                    {text: 'Septiembre', value: 9},
                    {text: 'Octubre', value: 10},
                    {text: 'Noviembre', value: 11},
                    {text: 'Diciembre', value: 12},
                ],
                filteredByDate: false,
                monthClosed: true,
                NewTypesItems: null,
                Currency: JSON.parse(localStorage.getItem('branch')).Currency,
                print: {
                    show: false,
                    data: [],
                    header: {},
                },
                dates: null,
                AccountListN: [],
                alert: {
                    show: false,
                    type: "info",
                    title: "",
                    message: "",
                    action: (() => null),
                },  
            }
        },
        mounted() {
            this.loading = true;
            this.getAllAcounts();
            this.getAcounteringTypes();
            if(this.entryTypes == null || this.entryTypes == undefined){
                    this.getAcounteringType();

            }
            else{
                this.getAcounteringHeader();
            }
        },
        methods: {
            formatGenerationCode(value) {
                const rawValue = String(value || '')
                    .replace(/-/g, '')
                    .replace(/\s/g, '')
                    .replace(/[^a-zA-Z0-9]/g, '')
                    .toUpperCase()
                    .slice(0, 32);
                const groupLengths = [8, 4, 4, 4, 12];
                const groups = [];
                let currentIndex = 0;

                for (const groupLength of groupLengths) {
                    if (currentIndex >= rawValue.length) {
                        break;
                    }
                    groups.push(rawValue.slice(currentIndex, currentIndex + groupLength));
                    currentIndex += groupLength;
                }

                return groups.join('-');
            },
            handleGenerationCodeInput(value) {
                const formattedCode = this.formatGenerationCode(value);
                if (this.search.generationCode !== formattedCode) {
                    this.search.generationCode = formattedCode;
                }
                this.search.filter = null;
            },
            getFilteredAccountingHeaders(search) {
                const { filter, generationCode, ...rest } = search;
                const params = generationCode
                    ? { ...rest, generationCode }
                    : { ...rest, filter };

                return this.$API.accountlevel.getAcountingHeaderFiltered(params);
            },
            filterByGenerationCode() {
                this.$refs.generalFilter.filterHandler();
            },
            clearGenerationCode() {
                this.search.generationCode = null;
                this.search.filter = null;
                this.getAcounteringHeader();
            },
            getAcounteringTypes() {
                this.$API.branchaccountcatalog
                    .getAcounteringType()
                    .then((res) => {
                        this.TypesItems = res.data;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            parseBoolean( booleanString ) {
                parseBoolean( booleanString )
            },
            showAlert(type, title, message, action) {
                type = type == null ? "info" : type;
                this.alert.type = type;
                this.alert.title = title;
                this.alert.message = message;
                this.alert.action = action ? action : (() => null);
                this.alert.show = true;
            },
            async getAllAcounts() {
                try {
                    const result = await this.$API.branchaccountcatalog.getActiveBranchAccountCatalog();
                    this.AccountListN = result.data;
                } catch (error) {
                    console.log(error);
                }
            },
            setDates(dates) {
                this.dates = dates
            },
            getFormattedDate() {
                const today = new Date();
                const day = String(today.getDate()).padStart(2, '0');
                const month = String(today.getMonth() + 1).padStart(2, '0'); // Los meses empiezan desde 0
                const year = today.getFullYear();
                return `${day}/${month}/${year}`;
            },
            async exportarPartidasDetalladas() {
                this.loading = true;
                let business = JSON.parse(localStorage.getItem('user')).business;
                let start = "";
                let end = "";

                const ordererAccountingEntries = [ ...this.itemsHistory ];

                ordererAccountingEntries.sort( ( a, b ) => {
                    if( a.ID_Accounting_item < b.ID_Accounting_item ) {
                        return -1;
                    } else if( a.ID_Accounting_item > b.ID_Accounting_item ) {
                        return 1;
                    }
                    return 0;
                } );

                if (!this.dates) {
                    start = this.getFormattedDate()
                    end = this.getFormattedDate()
                }
                else {
                    start = this.dates.start
                    end = this.dates.end
                }

                const { data: result } = await this.$API.accountingentryheader.getAccountingItemsDetails( ordererAccountingEntries );

                this.print = {
                    show: true,
                    data: result,
                    accounts: this.AccountListN,
                    header: { business, start, end}
                }
                this.loading = false;
            },
            onExportingToPdf() {
                const doc = new jsPDF(); // Crear PDF en modo horizontal
                
                const lastPoint = { x: 0, y: 0 };

                exportDataGrid({
                    jsPDFDocument: doc,
                    component: this.$refs["dataGrid"].instance,
                    topLeft: { x: 0, y: 10 },
                    font: 9,
                    columnWidths: [0, 0, 35, 25, 50, 35, 35],
                    customizeCell: function (options) {
                        options.pdfCell.font.size = 7;
                    },
                    customDrawCell({ rect }) {
                        if (lastPoint.x < rect.x + rect.w) {
                            lastPoint.x = rect.x + rect.w;
                        }
                        if (lastPoint.y < rect.y + rect.h) {
                            lastPoint.y = rect.y + rect.h;
                        }
                    },
                }).then(() => {
                    var pageCount = doc.internal.getNumberOfPages();
                    for(var i = 0; i < pageCount; i++){
                        doc.setPage(i);
                        let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;
                        doc.setFontSize(7)
                        doc.text ('page:  ' + pageCurrent + ' / ' + pageCount,10,10);

                        const header = 'Historial de Partidas Contables';
                        const pageWidth = doc.internal.pageSize.getWidth();
                        const headerWidth = doc.getTextDimensions(header).w;
                        doc.setFontSize(10);
                        doc.text(header, (pageWidth - headerWidth) / 2, 10);
                    }
                    doc.save('Reporte de Historial de Partidas Contables.pdf'); // Guardar el archivo PDF
                }).catch(error => {
                    console.error('Error durante la exportación a PDF:', error); // Manejo de errores
                });
            },
            onExporting(e) {
                //let array = null;
                //array = ["saldo_anterior"]
                printToExcel(e, "Encabezados de Partidas Contables");
            },
            accountingEntrySelected(data) {
                const { data: { id_accounting_entry: idAccountingEntry } } = data;
                let send = this.data.find( ( { id_accounting_entry } ) => id_accounting_entry == idAccountingEntry);
                // this.$store.commit('customerData/changeView', 'tab-1'); 
                this.$store.dispatch('addWindow', {
                    name: 'Acounting',
                    component: 'Acounting',
                    unique: false,
                    meta: { accountingEntryToModify: {...send} }
                })
            },
            async dateFilterHandler() {
                this.loading = true;
                const start = new Date(this.search.year, this.search.month - 1, 1); 
                const end = new Date(this.search.year, this.search.month, 0);

                const checkPeriod = await this.$API.accountlevel.getAcountingPeriodClosed({month: this.search.month, year: this.search.year});

                if(checkPeriod?.data?.is_closed == 1) {
                    this.monthClosed = true;
                }
                else {
                    this.monthClosed = false;
                }

                const response = await this.$API.accountlevel.getAcountingHeaderFilteredBydate({start, end, type: this.search.type});

                if(response.success && response.data) {
                    this.data = this.assignEntryTypes(response.data, true);
                    this.filteredByDate = true;
                }
                this.loading = false;
            },
            getAcounteringType() {
                this.$API.branchaccountcatalog
                    .getAcounteringType()
                    .then((res) => {
                    this.NewTypesItems = res.data;
                    this.getAcounteringHeader();

                    })
                    .catch((err) => {
                    console.log(err);
                    });
            },
            sendetails(data){
                this.$emit('sendetails', data)
            },
            getAcounteringHeader(){
                this.isFiltered = false;
                this.loading = true;
                this.$API.accountlevel.getAcountingHeader(this.search).then((res) => {
                    this.data = this.assignEntryTypes(res.data);
                    this.filteredByDate = false;
                    this.loading = false
                })
                .catch((err) => {
                    console.log(err);
                });
            },
            filterHandler(response) {
                this.isFiltered = true;
                this.data = this.assignEntryTypes(response.data);
            },
            assignEntryTypes(data, validateMissingItems = false) {
                
                for(const index in data) {
                    const {
                        id_accounting_entry_type,
                    } = data[index];
                    data[index].accounting_entry_type = !this.NewTypesItems ? this.entryTypes.find( current => current.id_accounting_entry_type === id_accounting_entry_type ).accounting_entry_code
                    : this.NewTypesItems.find( current => current.id_accounting_entry_type === id_accounting_entry_type ).accounting_entry_code;
                }
                if (validateMissingItems) {
                    this.searchMissingItems(data)
                }
                return data;
            },
            async auxFilter(filterObj) {
                const dataToFilter = await this.$API.accountlevel.getAcountingHeaderFiltered(filterObj);
                const filterArray = [
                    "accounting_entry_type"
                ];

                return new Promise( ( resolve, reject ) => {
                    try {
                        const filterResult = multipleCriteriaFilter( filterArray, filterObj, dataToFilter.length > 0 ? dataToFilter : this.data );

                        resolve( filterResult.length > 0 ? filterResult : dataToFilter );
                    } catch (error) {
                        reject( error );
                    }
                } );
                    
            },
            async handleFixCorrelatives() {
                this.loading = true;
                try {
                    const sortedData = this.data.sort(({accounting_entry_date : a}, {accounting_entry_date : b}) => a < b ? -1 : a > b ? 1 : 0);
                    //console.log(sortedData);
    
                    let aux = 0;
                    let month = null;
                    let year = null;
    
                    const updatedData = [];
    
                    for (const item of sortedData) {
                        const arrayDate = item.EntryFormatDate.split("/");
                        if(year != arrayDate[2]) {
                            year = arrayDate[2];
                            aux = 0;
                        }
                        if(month != arrayDate[1]) {
                            month = arrayDate[1];
                            aux = 0;
                        }
                        let number = 1 + aux;
    
                        let numberString = number.toString();
    
                        if(numberString.length < 6) {
                            for(let i = numberString.length; i < 6; i++) {
                                numberString = '0' + numberString;
                            }
                        }
                        const newCorrelative = `PC${year + month + numberString}`;
                        aux++;
    
                        item.ID_Accounting_item = newCorrelative;
    
                        updatedData.push({
                            ID_Accounting_item: newCorrelative,
                            id_accounting_entry: item.id_accounting_entry,
                            accounting_entry_date: item.accounting_entry_date
                        });
                        //console.log(newCorrelative);
                    }
                    const response = await this.$API.accountingentryheader.updateAccountingCorrelatives(updatedData);

                    if(response.success) {
                        //console.log(response);
                        this.loading = false;
                        this.showAlert("success", "Registros corregidos", `${response.message || 'Se corrigieron los correlativos de las partidas contables seleccionadas.'}`);
                        return this.data = sortedData.reverse();
                    }
                    else {
                        throw new Error('Ocurrio un error al corregir los correlativos.');
                    }
                } catch (error) {
                    console.log(error);
                    this.loading = false;
                    this.showAlert("danger", "Error", `${error.message || 'Ocurrio un error al corregir los correlativos.'}`);
                }
                
            },
            searchMissingItems(array) {
                if (this.search.type) {
                    return;
                }
                // 1. Agrupar por AñoMes
                const groups = array.reduce((acc, item) => {
                    const id = item.ID_Accounting_item || "";
                    const match = id.match(/^.{2}(\d{6})(\d{6})$/);

                    if (!match) {
                        return acc;
                    }

                    const period = match[1]; // Extrae "202508"
                    const correlative = {accountingNum: parseInt(match[2], 10), date: item.EntryFormatDate};

                    if (!acc[period]) acc[period] = [];
                    acc[period].push(correlative);
                    return acc;
                }, {});

                // let haySaltos = false;

                let jumps = [];
                let repeated = [];

                // 2. Evaluar cada mes de forma independiente
                for (const periodo in groups) {
                    // Ordenar los correlativos de este mes específico
                    const numbers = groups[periodo].sort((a, b) => a.accountingNum - b.accountingNum);

                    let jumpsMonth = [];

                    if (numbers.length > 0 && numbers[0].accountingNum > 1) {
                        jumpsMonth.push(numbers[0]);
                    }

                    for (let i = 0; i < numbers.length - 1; i++) {
                        let current = numbers[i];
                        let next = numbers[i + 1];

                        if (next.accountingNum === current.accountingNum) {
                            repeated.push(next);
                        }

                        if (next.accountingNum > current.accountingNum + 1) {
                            jumpsMonth.push(current);
                        }
                    }

                    if (jumpsMonth.length > 0) {
                        jumps = [...jumps, ...jumpsMonth];
                    }
                }

                if (jumps.length > 0 || repeated.length > 0) {
                    const fechas = [...jumps, ...repeated].map(item => item.date).join(', ');
                    this.showAlert("warning", "Aviso", `Se detectaron saltos o correlativos repetidos en la secuencia para las fechas ${fechas}. Para corregirlo puede utilizar la funcionalidad de Corregir correlativos.`);
                }
            }
        },
    }
</script>
